import { deleteWebIntegrationApiRequest, getAllWebIntegrationsApiCall, saveWebIntegrationApiCall } from '@guryou/api-client-gql';

import { WEB_INTEGRATIONS_CREATE, WEB_INTEGRATIONS_DELETE, WEB_INTEGRATIONS_GET_MANY } from '../types';

import { execute } from './actionWrapper';

const getAllWebIntegrations = () => async dispatch =>
  execute(
    dispatch,
    () =>
      getAllWebIntegrationsApiCall({
        configuration: [
          'showVideos',
          'showServices',
          'showEvents',
          'showCourses',
          'showMemberships',
          'showPlans',
          'primaryColor',
          'askEmail',
          'askFirstname',
          'askLastname',
          'askPhone',
          'fontFamily',
          'fontStyle',
          'authLoginBackground',
          'authLoginText',
          'authLoginBorder',
          'authLoginBorderWidth',
          'authRegisterBackground',
          'authRegisterText',
          'authRegisterBorder',
          'authRegisterBorderWidth',
          'authButtonBorderRadius',
          'authVisibleButtons',
        ],
      }),
    WEB_INTEGRATIONS_GET_MANY
  );

const saveWebIntegration = data => async dispatch => {
  const {
    showVideos,
    showServices,
    showEvents,
    showCourses,
    showMemberships,
    showPlans,
    askEmail,
    askFirstname,
    askLastname,
    askPhone,
    fontFamily,
    fontStyle,
    id,
    ...rest
  } = data;
  const request = {
    showVideos: !!showVideos,
    showServices: !!showServices,
    showEvents: !!showEvents,
    showCourses: !!showCourses,
    showMemberships: !!showMemberships,
    showPlans: !!showPlans,
    askEmail: !!askEmail,
    askFirstname: !!askFirstname,
    askLastname: !!askLastname,
    askPhone: !!askPhone,
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    id: +id,
    ...rest,
  };

  execute(dispatch, () => saveWebIntegrationApiCall({ request }), WEB_INTEGRATIONS_CREATE);
};

const deleteWebIntegration = id => async dispatch => execute(dispatch, () => deleteWebIntegrationApiRequest(id), WEB_INTEGRATIONS_DELETE);

export { deleteWebIntegration, getAllWebIntegrations, saveWebIntegration };
